// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".articleModal[data-v-08d016f2] {\n  z-index: 333 !important;\n}", ""]);
// Exports
module.exports = exports;
